import { generateUUID } from "../../../../../services/helpers/Helper";
import { TYPE_POPOVER } from "../components/editor/constants";

export const BLOCK_DEFAULT = {
   title: "Nút mới #",
   type: TYPE_POPOVER.ICEBREAKER,
   cards: [
   ],
   is_hidden: 0,
   is_first_block: 0,
   block_content_type: ""
}